import styled from "styled-components";
import { V3EmptyState } from "./V3EmptyStateScreen";

export const MPUEmptyState = styled(V3EmptyState)`
    aspect-ratio: 16 / 9;
`;

export const MPUButtons = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
`;
